import styled from 'styled-components';
import { colors } from '../../../../utils/utils';

export const EvaluationItem = styled('div')`
    display: block;
    padding: 8px 16px 8px 16px;
    margin-bottom: 8px;
    cursor: pointer;
    border-bottom: 1px solid #ccc;
    border-radius: 4px 4px 0 0;

    &:hover {
        border-color: ${colors.blue.i2x};

        b {
            color: ${colors.blue.i2x};
        }
    }

    &:last-child {
        border-bottom: none;
        margin-bottom: 0;
    }
`;

export const EvaluationItemRating = styled('div')`
    font-weight: bold;
    background-color: ${colors.gray.wild_sand};
    padding: 2px 4px;
    border-radius: 4px;
`;
